import {StackPanel} from "../panels/StackPanel";
import {Button} from "@mui/material";
import React from "react";
import {useAppDispatch} from "../../hooks/ReduxHooks";
import {BlankUser} from "../../state/UsersState";
import {ItemActions} from "../../actions/ItemActions";

export const UserControlsView = () => {
    const dispatch = useAppDispatch();

    function onCreateNewUser() {
        dispatch(ItemActions.showItemContent({...BlankUser}));
    }

    return (
        <StackPanel orientation="horizontal"
                    className="panel">

            <Button variant="contained" onClick={onCreateNewUser}>New User</Button>
        </StackPanel>
    );
}
